<template>
  <div class="guidefile">
    <div class="g-top">
      <div class="g-top-l">
        <el-input v-model="search" placeholder="文件名称" style="width: 200px;" size="small"></el-input>
        <el-date-picker v-model="stareleasetime" type="date" placeholder="开始时间" @change="statimeChange" style="width: 120px;" size="small">
        </el-date-picker>
        -
        <el-date-picker v-model="endreleasetime" type="date" placeholder="结束时间" @change="endtimeChange" style="width: 120px;" size="small">
        </el-date-picker>
        <el-select v-model="category" size="small" placeholder="请选择类型" style="width: 200px;" @change='change'>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" @click="searchArr">搜索</el-button>
        <el-button size="small" @click="closesearch">重置</el-button>
      </div>
    </div>
    <div class="g-box">
      <HeavyPoll @currentChange='currentChange' ref="heavypoll" :arrList="arrList"></HeavyPoll>
      <div style="text-align: right;margin-top: 10px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 25, 50]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import burst from '@/data/basic/manage/guidefile'
import BurstTab from './bursttab'
import HeavyPoll from './heavypoll'
import moment from 'moment'
export default {
  data() {
    return {
      activeName: 'first',
      currentId: null,
      // 查询
      search: '',
      stareleasetime: '',
      endreleasetime: '',
      category: '',
      options: [{
        value: '1',
        label: '法律法规规章制度'
      }, {
        value: '2',
        label: '重污染天气'
      }, {
        value: '3',
        label: '突发环境事件'
      }, {
        value: '4',
        label: '其他'
      }],
      // 数据列表
      arrList: [],
      // 单列详情
      detailInfo: {},
      currentPage4: 1,
      total: 0,
      size: 10,
      page: 0,
      deleteState: false,
    }
  },
  components: {
    BurstTab,
    HeavyPoll,
  },
  created() {
    this.search_guidance()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.search_guidance({
        keyword: this.search,
        startReleaseDate: this.stareleasetime,
        endReleaseDate: this.endreleasetime,
        categories: this.category,
        size: this.size
      })
    },
    handleCurrentChange(val) {
      this.page = val - 1
      this.search_guidance({
        keyword: this.search,
        startReleaseDate: this.stareleasetime,
        endReleaseDate: this.endreleasetime,
        categories: this.category,
        page: this.page,
        size: this.size
      })
    },
    // 查询
    searchArr() {
      this.search_guidance({
        keyword: this.search,
        startReleaseDate: this.stareleasetime,
        endReleaseDate: this.endreleasetime,
        categories: this.category
      })
    },
    // 重置
    closesearch() {
      this.search_guidance()
      this.search = '',
        this.stareleasetime = '',
        this.endreleasetime = '',
        this.category = ''
    },
    // 结束日期
    statimeChange(val) {
      if (val) {
        this.stareleasetime = moment(val).format('YYYY-MM-DD 00:00:00')
      }
    },
    // 结束时间
    endtimeChange(val) {
      if (val) {
        this.endreleasetime = moment(val).format('YYYY-MM-DD 00:00:00')
      }
    },
    // 类型
    change(val) {
      this.category = val
    },
    currentChange(id) {
      this.currentId = id
    },
    // 调用查询的接口
    async search_guidance(params) {
      try {
        let arr = await burst.search_file_guidance(params)
        if (arr.status) {
          this.arrList = arr.data.content
          this.total = arr.data.totalElements
        }
      } catch (err) {
        this.$message.error(err.msg)
      }
    },
    // 详情的接口
    async detail_guidance(params) {
      try {
        let detail = await burst.detail_file_guidance(params)
        if (detail.status) {
          sessionStorage.detailInfo = JSON.stringify(detail.data)
        }
      } catch (error) {
        this.$message.error(error.msg)
      }
    }
  }
}

</script>
<style lang="stylus" scoped>
.g-top {
  position: resolve;
  width: 100%;
  height: 40px;
  margin-top: 5px;
  border-bottom: 1px solid #eee;
  .g-top-l {
    float: left;
  }
  .gf-btn {
    float: right;
  }
}

.g-box {
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// guidefile.vue?3022b5f2